import PrimaryLayout from './PrimaryLayout'
export default PrimaryLayout
